import * as yup from 'yup'
import { gt } from 'svelte-i18n-lingui'

export const addressSchema = yup.object().shape({
	lastname: yup.string().required(gt`Surname required`),
	firstname: yup.string().required(gt`Name required`),
	street: yup.string().required(gt`Street required`),
	city: yup.string().required(gt`City required`),
	region: yup.string().required(gt`Region required`),
	postcode: yup.string().required(gt`Postcode required`),
	country_id: yup.string().required(gt`Country required`),
	telephone: yup.string().required(gt`Phone required`),
	default_billing: yup.boolean(),
	default_shipping: yup.boolean(),
})

export const customerInfoSchema = yup.object().shape({
	firstname: yup.string().required(gt`Name required`),
	lastname: yup.string().required(gt`Surname required`),
	email: yup.string().required(gt`Email required`).email(),
})

export const passwordSchema = yup.object().shape({
	currentPassword: yup.string().required(gt`Password required`),
	newPassword: yup
		.string()
		.label(gt`confirm password`)
		.required(gt`Add new password`)
		.min(8, gt`Password must be at least 8 characters long`)
		.matches(/[0-9]/, gt`Password requires a number`)
		.matches(/[a-z]/, gt`Password requires a lowercase letter`)
		.matches(/[A-Z]/, gt`Password requires an uppercase letter`),
	confirmNewPassword: yup
		.string()
		.label(gt`Confirm password`)
		.required(gt`Please confirm your password`)
		.oneOf([yup.ref('newPassword'), ''], gt`Passwords must match`),
})

export const trackOrderSchema = yup.object().shape({
	increment_id: yup.string().required(gt`Number required`).matches(/^\d+$/, gt`Must contain numbers`),
	email: yup.string().required(gt`Email required`).email(),
})

export const cancelOrderSchema = yup.object().shape({
	email: yup.string().required(gt`Email required`).email(),
	increment_id: yup.string().required(gt`Number required`).matches(/^\d+$/, gt`Must contain numbers`),
	comments: yup.string()
})

export const confirmationEmailSchema = yup.object().shape({
	email: yup.string().required(gt`Email required`).email(),
	name: yup.string().required(gt`Name required`)
})
